// AtrWidget/AtrFetcher.js
// Singleton — does exactly 1 thing: raw I/O via HistoryService. No mapping, no business logic.
import historyService from '../../../services/HistoryService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'AtrFetcher';

class AtrFetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches today's ATR (Per7/14/30/60/120/200) for ALL assets in one call (sid=0).
     * @returns {Promise<{rk:string,ems:number,symbol:string,sid:number,per7:object,per14:object,per30:object,per60:object,per120:object,per200:object,eventOpt:string}[]>}
     */
    fetchAll = async () => {
        try {
            const res = await historyService.getAtr(0);
            return res?.data?.items ?? [];
        } catch (error) {
            this.logError('fetchAll', error.message);
            return [];
        }
    };
}

const atrFetcher = new AtrFetcher();
export default atrFetcher;
